<template>
  <section v-if="loading">
    <BaseSpinner
      height="100px"
      width="100px"
      v-if="spinning"
    />
  </section>
  <section v-else>
    <slot />
  </section>
</template>

<script>
import BaseSpinner from '../components/BaseSpinner.vue';

export default {
    name: 'Page',
    components: { BaseSpinner },
    props: {
        loading: { type: Boolean, required: true },
        spinning: { type: Boolean, required: true },
    },
};
</script>
